// Remove the hook usage - this will be handled in components instead
export const handleApiError = (error: any, description: string) => {
    console.error('API Error:', error);
    
    // Return error details for components to handle
    return {
      title: "Error",
      message: error.message || description,
      variant: "destructive" as const,
    };
};
